import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Grid,
  Stepper,
  Step,
  StepLabel,
  Stack,
  Typography,
  StepConnector,
} from "@mui/material";

import "./../formStyle.scss";

import {
  DYNAMIC_STEPS,
  ERROR_MESSAGE,
  INITIAL_STEPS,
} from "../../config/constant";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  getApplicantDetails,
  getMasterDataList,
  getOppprtunityDetails,
  setActiveStep,
  setApplicantActiveStep,
  setApplicantTotal,
  setIsLoading,
  setProjectBrandImage,
  setPartnerHeaderImage,
  setResetData,
  setShowMobileStepper,
  setShowSaveAndPreview,
  getTermsAndCondition,
} from "./new-booking-form.slice";
import ReviewDetailStepIcon from "../../assets/component-icon/ReviewDetailStepIcon";
import PaymentDetailStepIcon from "../../assets/component-icon/PaymentDetailStepIcon";
import TermsConditionStepIcon from "../../assets/component-icon/TermsConditionStepIcon";
import ApplicantDetailStepIcon from "../../assets/component-icon/ApplicantDetailStepIcon";
import TermsAndCondition from "./components/terms-and-condition/TermsAndCondition";
import Header from "../../layout/header/Header";
import SnackbarAlert from "../../shared-components/snackbar-alert/SnackbarAlert";
import Arrowgreen from "../../assets/icons/line2.svg";
import ApplicantCount from "./components/ApplicantCount";
import ApplicantDetails from "./Individual-components/ApplicantDetails";
import ReviewDetails from "./components/ReviewDetails/ReviewDetails";
import CorporatePaymentOption from "./components/CorporatePaymentOptions";
import StepperIconRoot from "../../shared-components/stepper/StepperIconRoot";
const IndividualCustomerForm = () => {
  const dispatch = useDispatch();
  const {
    activeStep,
    applicantTotal,
    applicantData,
    showMobileStepper,
    applicantActiveStep,
    checkFirstStepCompleted,
    applicantActiveStep1,
    applicantActiveStep2,
  } = useSelector((state) => state.newBookingForm);
  const { oppId } = useParams();
  const [steps, setSteps] = useState([]);
  const [stepsArray, setStepsArray] = useState([]);
  const [lastStep, setLastStep] = useState(0);
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    setLastStep(applicantData?.lastStep);
    let newArray = DYNAMIC_STEPS.slice(0, applicantTotal);
    let initialSteps = INITIAL_STEPS.map((data, index) => {
      return {
        label: "Step " + (applicantTotal + index + 1),
        description: data.description,
      };
    });

    let applicantDetailArray = newArray.map((data, index) => {
      return <ApplicantDetails key={data.description} applicantNo={index + 1} />;
    });
    let remainingDetailArray = [
      <ReviewDetails />,
      <CorporatePaymentOption />,
      <TermsAndCondition />,
    ];

    setSteps([...newArray, ...initialSteps]);
    setStepsArray([...applicantDetailArray, ...remainingDetailArray]);

    return () => {};
  }, [applicantTotal, activeStep, applicantData]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (oppId?.length > 0) {
        dispatch(getOppprtunityDetails(`/${oppId}`))
          .unwrap()
          .then((res) => {
            if (res?.data !== null) {
              dispatch(
                getTermsAndCondition(`/${res?.data?.ProjectName}`)
              )
                .unwrap()
                .then((data) => {
                  dispatch(setIsLoading(true));

                  let projectImage = data?.projectImage || "";
                  let jvPartnerLogo = data?.jvPartnerLogo || "";
                  dispatch(setProjectBrandImage(projectImage));

                  dispatch(
                    setPartnerHeaderImage(jvPartnerLogo)
                  );

                  dispatch(setIsLoading(false));
                })
                .catch(() => {
                  dispatch(setProjectBrandImage(""));
                  dispatch(setPartnerHeaderImage(""));
                });
            }
          })
          .catch((error) => {});

        dispatch(getMasterDataList());
        dispatch(getApplicantDetails(`/${oppId}`))
          .unwrap()
          .then((res) => {
            if (res) {
              dispatch(setApplicantTotal(res?.noOfApplicants));

            }
          })
          .catch((error) => {
            dispatch(setResetData());
            if (!error?.errors?.message?.includes("Booking with Opportunity")) {
              setSnackbarConfig({
                open: true,
                message: ERROR_MESSAGE,
                severity: "error",
              });
            }
          });
      }
    }, 300);

    return () => clearTimeout(debounceTimeout);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      applicantData?.applicant2?.hasContinuedAsMinor &&
      applicantTotal === 1
    ) {
      dispatch(setApplicantTotal(applicantData?.noOfApplicants));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantData]);  

  function ColorlibStepIcon(props) {
    const { active, className, icon } = props;
    const isStepCompleted =
      applicantData?.applicant1?.professionalDetails &&
      checkFirstStepCompleted === false &&
      lastStep >= icon;
    const icons = {};
    const isStepActiveAndCompleted = isStepCompleted && active;
    const nextStepIcons = {
      1: (
        <ReviewDetailStepIcon
          // show={Boolean(active)}
          completed={isStepCompleted}
        />
      ),
      2: (
        <PaymentDetailStepIcon
          show={Boolean(active)}
          completed={isStepCompleted}
        />
      ),
      3: (
        <TermsConditionStepIcon
          show={Boolean(active)}
          completed={isStepCompleted}
        />
      ),
    };

    let applicantDetailSteps = DYNAMIC_STEPS.slice(0, applicantTotal);

    for (let index = 0; index < applicantDetailSteps.length; index++) {
      icons[index] = (
        <ApplicantDetailStepIcon show={active} completed={isStepCompleted} />
      );
    }

    const maxIndex = Math.max(...Object.keys(icons).map(Number));

    Object.keys(nextStepIcons).forEach((key, index) => {
      icons[maxIndex + index + 1] = nextStepIcons[key];
    });

    return (
      <StepperIconRoot
        ownerState={{
          active,
          isStepCompleted,
          variant: "default",
        }}
        className={className}
      >
        {icons[props.icon]}
        <div className="step-label">
          {isStepActiveAndCompleted && (
            <img
              src={Arrowgreen}
              alt="Completed Step"
              className="arrowTriangleLeft"
              // style={{
              //   width: "7px",
              //   marginLeft: "6px",
              //   position: "absolute",
              //   right: showMobileStepper ? "63%" : "70%",
              //   top: "5px",
              // }}
            />
          )}
        </div>
      </StepperIconRoot>
    );
  }

  const getForm = (step) => {
    return stepsArray[step];
  };

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };
  const handleStep = (step) => () => {
    dispatch(setShowMobileStepper(false));
    if (lastStep >= step) {
      dispatch(setShowSaveAndPreview(false))

      dispatch(setActiveStep(step));
      if (
        step + 1 <= applicantData?.noOfApplicants &&
        step + 1 !== 3 &&
        step + 1 !== 4
      ) {
        if (step + 1 === 1) {
          dispatch(setApplicantActiveStep(applicantActiveStep1));
        }
        if (step + 1 === 2) {
          dispatch(setApplicantActiveStep(applicantActiveStep2));
        }
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [applicantActiveStep, activeStep]);

  useEffect(() => {
    if (
      activeStep + 1 <= applicantData?.noOfApplicants &&
      activeStep + 1 !== 3 &&
      activeStep + 1 !== 4
    ) {
      if (activeStep + 1 === 1) {
        dispatch(setApplicantActiveStep(applicantActiveStep1));
      }
      if (activeStep + 1 === 2) {
        dispatch(setApplicantActiveStep(applicantActiveStep2));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  return (
    <>
      <Helmet>
        <title>Booking Application Form - Puravankara</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {activeStep === null ? (
        <ApplicantCount />
      ) : (
        <>
          <Header
          onToggleMenu={() => dispatch(setShowMobileStepper(!showMobileStepper))}
           />
          <Stack>
            <Grid
              container
              spacing={0}
              sx={{
                p: 0,
                paddingLeft: {
                  xs: "16px",
                  sm: "16px",
                  md: "16px",
                  lg: "7%",
                },
                paddingRight: {
                  xs: "16px",
                  sm: "16px",
                  md: "16px",
                  lg: "7%",
                },
                mb: {
                  xs: 2,
                  sm: 4,
                  md: 5, // Desktop
                },
              }}
            >
              <Grid
                item
                xs={12}
                sx={{
                  textAlign: {
                    xs: "center",
                    sm: "center",
                    md: "center",
                  },
                  pt: {
                    xs: "16px",
                    sm: "30px",
                    md: "36px",
                  },
                  pb: {
                    xs: "16px",
                    sm: "18px",
                    md: "20px",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: "#1A407D",
                    fontSize: {
                      xs: "20px",
                      sm: "20px",
                      md: "24px",
                    },
                    fontWeight: "700",
                    lineHeight: {
                      xs: "28px",
                      sm: "32px",
                      md: "36px",
                    },
                    mb: {
                      xs: 0.5,
                      sm: 1,
                      md: 1,
                    },
                  }}
                >
                  Booking Application Form
                </Typography>
                <Typography
                  sx={{
                    color: "#1C252E",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "22px",
                  }}
                >
                  Enter the details to get going
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box
                  className={`mobileDrawer ${
                    showMobileStepper === true ? "OpenDrawer" : ""
                  }`}
                  sx={{
                    borderRadius: "8px",
                    border: "1px solid rgba(26, 64, 125, 0.30)",
                  }}
                >
                  <div className="mobileDrawerOverly"> </div>
                  <div className="mobileDrawerBox">
                    <Stepper
                      activeStep={activeStep}
                      orientation="vertical"
                      connector={
                        <StepConnector
                          sx={{
                            ml: "19px",
                          }}
                        />
                      }
                      sx={{
                        "& .MuiStepConnector-line": {
                          border: "0px",
                          borderLeft: "2px dotted #D6D6D6",
                          minHeight: "34px",
                          // borderColor: activeStep === 0 ? "#D6D6D6" : "#1A407D",
                          // borderLeftStyle: activeStep === 0 ? "dotted" : "solid",
                        },
                        "& .MuiStepLabel-label": {
                          color: activeStep === 0 ? "green" : "blue",
                        },
                        "& .MuiStepIcon-root": {
                          color: activeStep === 0 ? "orange" : "purple",
                        },
                      }}
                    >
                      {steps.map((step, index) => {
                        return (
                          <Step key={step.description}>
                            <StepLabel
                              StepIconComponent={(props) => (
                                <ColorlibStepIcon {...props} icon={index} />
                              )}
                              sx={{
                                p: 0,
                                cursor: "pointer",
                                position: "relative",
                              }}
                              onClick={handleStep(index)}
                            >
                              <Typography
                                sx={{
                                  color: "#7A7A7A",
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  lineHeight: "18px",
                                  mb: "3px",
                                }}
                              >
                                {step.label}
                              </Typography>
                              <Typography
                                sx={{
                                  color: "#1C252E",
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  lineHeight: "22px",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: step.description,
                                }}
                              ></Typography>
                            </StepLabel>
                          </Step>
                        );
                      })}
                    </Stepper>
                  </div>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={9}>
                <Box
                  sx={{
                    borderRadius: "8px",
                    border: "1px solid rgba(26, 64, 125, 0.30)",
                    padding: {
                      xs: "16px",
                      sm: "16px",
                      lg: "26px 39px 26px 39px",
                    },
                    marginLeft: {
                      xs: "0",
                      sm: "0",
                      lg: "24px",
                    },
                  }}
                >
                  {getForm(activeStep)}
                </Box>
              </Grid>
            </Grid>
          </Stack>
        </>
      )}
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};



IndividualCustomerForm.propTypes = {
  active: PropTypes.any,
  className: PropTypes.any,
  icon: PropTypes.any,
};

export default IndividualCustomerForm;
